import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, Input, Checkbox, Button } from '@chakra-ui/react';
import { MailingListType } from '../Table/MaintenanceMailingListTable';
import { QueryMailingListApi } from '../../../../apis/QueryMaintenance.api';
import { MailingListSearchCondition } from '../../../../pages/MailingListMaintenance';

interface props {
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<MailingListType[] | undefined>
  >;
  Query: MailingListSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<MailingListSearchCondition>>;
  createOrUpdate: boolean;
  SearchStateSwitch: () => void;
}

const MailingListSearchBox: React.FC<props> = (props) => {
  const {
    setMaintenanceDatas,
    Query,
    setQuery,
    createOrUpdate,
    SearchStateSwitch
  } = props;

  const [email, setEmail] = useState('');
  const [enable, setEnable] = useState(false);
  const [dateCreatedFrom, setDateCreatedFrom] = useState('');
  const [dateCreatedTo, setDateCreatedTo] = useState('');
  const [dateUpdatedFrom, setDateUpdatedFrom] = useState('');
  const [dateUpdatedTo, setDateUpdatedTo] = useState('');

  useEffect(() => {
    setEmail('');
    setEnable(false);
    setDateCreatedFrom('');
    setDateCreatedTo('');
    setDateUpdatedFrom('');
    setDateUpdatedTo('');
  }, [createOrUpdate]);

  const SerachGetApi = async () => {
    const params = new URLSearchParams();
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    email !== '' && params.append('email_contains', email);
    enable && params.append('enable', 'true');
    dateCreatedFrom !== '' && params.append('created_at_gte', dateCreatedFrom);
    dateCreatedTo !== '' && params.append('created_at_lt', dateCreatedTo);
    dateUpdatedFrom !== '' && params.append('updated_at_gte', dateUpdatedFrom);
    dateUpdatedTo !== '' && params.append('updated_at_lt', dateUpdatedTo);
    const apiQuery = '/?' + params.toString();

    setQuery((pre) => ({
      ...pre,
      email: email,
      enable: enable,
      dateCreatedFrom: dateCreatedFrom,
      dateCreatedTo: dateCreatedTo,
      dateUpdatedFrom: dateUpdatedFrom,
      dateUpdatedTo: dateUpdatedTo
    }));

    const response = await QueryMailingListApi(apiQuery);
    if (response.success) {
      setMaintenanceDatas(response.data as MailingListType[]);
      SearchStateSwitch();
    }
  };

  return (
    <>
      <Box
        border='1px'
        borderColor='gray'
        ml={14}
        gridRow='2/3'
        gridColumn='2/2'
        w='80%'
        h='330px'
        bgColor='#f4f4f4'
      >
        <Box bgColor='#e5e6e7'>
          <Text>検索条件</Text>
        </Box>
        <Box w='90%'>
          <Text ml={2} mt={1}>
            メールアドレスで絞り込む
          </Text>
          <Input
            ml={2}
            bgColor='white'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Input>
          <Text ml={2} mt={1}>
            有効
          </Text>
          <Checkbox
            ml={2}
            bgColor='white'
            isChecked={enable}
            onChange={(e) => {
              setEnable(e.target.checked);
            }}
          ></Checkbox>
          <Text ml={2} mt={1}>
            登録日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedFrom}
              onChange={(e) => setDateCreatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedTo}
              onChange={(e) => setDateCreatedTo(e.target.value)}
            />
          </HStack>
          <Text ml={2} mt={1}>
            更新日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedFrom}
              onChange={(e) => setDateUpdatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedTo}
              onChange={(e) => setDateUpdatedTo(e.target.value)}
            />
          </HStack>
          <Button
            ml={2}
            mt={2}
            bgColor='gray.800'
            color='white'
            onClick={() => SerachGetApi()}
          >
            絞り込む
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default React.memo(MailingListSearchBox);
